import { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'fr');

  const isRTL = lang === 'ar';

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
    localStorage.setItem('theme', theme);
    localStorage.setItem('lang', lang);
  }, [theme, lang, isRTL]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  const t = (section, key, vars = {}) => {
    let str = translations[lang]?.[section]?.[key] || translations['en']?.[section]?.[key] || key;
    Object.entries(vars).forEach(([k, v]) => { str = str.replace(`{{${k}}}`, v); });
    return str;
  };

  return (
    <SettingsContext.Provider value={{ theme, toggleTheme, lang, setLang, isRTL, t }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
